
// https://stackoverflow.com/questions/8022885/rgb-to-hsv-color-in-javascript/54070620#54070620

const rgbToHsv = ([r, g, b]) => {
  const nr = r / 255;
  const ng = g / 255;
  const nb = b / 255;
  const v = Math.max(nr, ng, nb);
  const c = v - Math.min(nr, ng, nb);
  let x;

  if (v === nr) {
    x = (ng - nb) / c;
  } else if (v === ng) {
    x = 2 + (nb - nr) / c;
  } else {
    x = 4 + (nr - ng) / c;
  }

  const h = c && x;
  return [60 * (h < 0 ? h + 6 : h), (v && c / v) * 100, v * 100];
};

// https://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately/54024653#54024653

const hsvToRgb = ([h, s, v]) => {
  const ns = s / 100;
  const nv = v / 100;
  const f = (n) => {
    const k = (n + h / 60) % 6;
    return Math.round((nv - nv * ns * Math.max(Math.min(k, 4 - k, 1), 0)) * 255);
  };
  return [f(5), f(3), f(1)];
};

const rev180 = (a) => {
  let r = a;

  if (a > 180) {
    r = (a % 360) - 360;
  } else if (a < -180) {
    r = (a % 360) + 360;
  }

  return r;
};

const rampColor = (colors, ratio) => {
  if (ratio <= 0) {
    return colors[0];
  }

  if (ratio >= 1) {
    return colors[colors.length - 1];
  }

  let r = ratio * (colors.length - 1);
  const i = Math.floor(r);
  const j = i + 1;
  r -= i;

  /* eslint-disable prefer-const */
  let [fh, fs, fv] = rgbToHsv(colors[i]);
  let [th, ts, tv] = rgbToHsv(colors[j]);
  /* eslint-enable prefer-const */

  if (fs === 0 && ts > 0) {
    fh = th;
  } else if (ts === 0 && fs > 0) {
    th = fh;
  }

  const h = (360 + (fh + (rev180(th - fh) * r))) % 360;
  const s = fs + ((ts - fs) * r);
  const v = fv + ((tv - fv) * r);

  return hsvToRgb([h, s, v]);
};

export default rampColor;
